import "../demoStyles/Navbar.css"


function Navbar() {
  return (
    <>

      <div className="nav" activeKey="/home">
        <p className="logo">RugHalt</p>

      </div>

    </>
  );
}

export default Navbar